module.exports = __webpack_public_path__ + "img/tpc-6.a78a54e0.webp";